module.exports = __webpack_public_path__ + "img/Weapon_87.1e8e0c4f.png";